import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDateFnsModule } from '@angular/material-date-fns-adapter';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CompraFotoComponent } from './compra-foto/compra-foto.component';
import { FormFotoComponent } from './form-foto/form-foto.component';
import { BasicHeaderComponent } from './basic-header/basic-header.component';
import { SharedModule } from 'projects/shared/src/public-api';
import { TranslocoRootModule } from '@socios/transloco-root.module';

@NgModule({
  declarations: [
    AppComponent,
    BasicHeaderComponent,
    CompraFotoComponent,
    FormFotoComponent
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatCardModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatDateFnsModule,
    TranslocoRootModule,
    SharedModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
